import fetch from '@/plugin/axios'

// 添加勋章
export function getAddMedal (query) {
  return fetch({
    url: '/api/member/medal/add',
    method: 'Post',
    data: query
  })
}

// 勋章列表
export function getMedalList (query) {
  return fetch({
    url: '/api/member/medal/list',
    method: 'Post',
    data: query
  })
}

// 修改勋章
export function getModifyMedal (id, query) {
  return fetch({
    url: `/api/member/medal/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 勋章信息
export function getInfo (id) {
  return fetch({
    url: `/api/member/medal/info/${id}`,
    method: 'Get'
  })
}

// 发送勋章
export function sendOut (id, query) {
  return fetch({
    url: `/api/member/medal/send/${id}`,
    method: 'Post',
    data: query
  })
}
